// Legal-entity → document branding. Only explicitly configured entities carry a logo;
// any other legal company renders a neutral, text-only identity (no Alvora branding).
const BRANDS = {
  alvora: {
    key: 'alvora',
    legalName: 'Alvora Construction Ltd',
    wordmark: '/brand/alvora-wordmark-color.png',
    wordmarkDark: '/brand/alvora-wordmark-white.png',
    mark: '/brand/alvora-mark-color.png',
    tagline: 'Crafting Exceptional Homes',
  },
};

const match = (name = '') => /alvora/i.test(name) ? BRANDS.alvora : null;

export function resolveDocumentBrand({ businessUnit, organisation } = {}) {
  const legalName = businessUnit?.legal_entity_name || businessUnit?.name || organisation?.name || '';
  const brand = match(legalName);
  return {
    legalName: legalName || 'Company',
    brand,                              // null → neutral header
    divisionName: businessUnit && businessUnit.unit_type !== 'legal_entity' ? businessUnit.name : null,
  };
}
